import { Heading as PropsHeading } from '@/models/Props';

import { LGridSystem } from '@/components/layouts';

import './Heading.scss';

const Heading = ({ type, contentPerLine }: PropsHeading) => {
    const HeadingTag = type;

    return (
        <LGridSystem
            className={'heading'}
            sortChildren={'rows'}
            positioning={{ justifyItems: 'center' }}
        >
            <div>
                <HeadingTag>
                    {contentPerLine.map((line) => `${line}\n`)}
                </HeadingTag>
            </div>
        </LGridSystem>
    );
};

export default Heading;
